import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './PricingHeader.css';

function PricingHeader() {
    const { t } = useTranslation();

    return (
        <div className='pricing-header' style={{ backgroundImage: 'url(/images/homepage-header.png' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip'>
                        {t('Flexible Plans for Every Property')}
                    </div>
                    <h1 className='mt-3'>{t('Discover Your Ideal Hotel Software Price with Prostay’s Flexible Plans')}</h1>
                    <p className='body-large'>
                        {t('Whether you operate a boutique hotel, a multi-property resort, or a growing vacation-rental brand, \n' +
                            'Prostay’s modular hotel software pricing lets you activate - and pay for - only the features you need. \n' +
                            'Clear month-to-month terms mean no hidden fees or long-term contracts, and you can add or remove modules at any time, so your plan scales effortlessly with your business.\n')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img className='center-content-img-width' src='/images/pricing.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default PricingHeader;
